import React from 'react';
import { 
  ChartBarIcon, 
  ChartPieIcon, 
  WalletIcon, 
  DocumentChartBarIcon,
  CogIcon,
  PlayIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';

const Navigation = ({ currentPage, onPageChange }) => {
  const menuItems = [
    { 
      id: 'dashboard', 
      label: 'Dashboard', 
      icon: ChartBarIcon,
      description: 'View trading activity'
    },
    { 
      id: 'stats', 
      label: 'Statistics', 
      icon: ChartPieIcon,
      description: 'Performance analytics'
    },
    { 
      id: 'wallet', 
      label: 'Wallet', 
      icon: WalletIcon,
      description: 'Manage wallets'
    },
    { 
      id: 'portfolio', 
      label: 'Portfolio', 
      icon: DocumentChartBarIcon,
      description: 'Portfolio overview'
    },
    { 
      id: 'settings', 
      label: 'Settings', 
      icon: CogIcon,
      description: 'Trading configuration'
    },
    { 
      id: 'transactions', 
      label: 'Transactions', 
      icon: DocumentTextIcon,
      description: 'Real transaction history'
    },
    { 
      id: 'mock-trades', 
      label: 'Mock Trades', 
      icon: PlayIcon,
      description: 'Simulated trading environment'
    }
  ];

  return (
    <nav className="glass-nav rounded-2xl p-6 mb-8 animate-slide-up">
      <div className="flex flex-wrap justify-center lg:justify-start gap-3">
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = currentPage === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onPageChange(item.id)}
              className={`group relative flex items-center space-x-3 px-6 py-3 rounded-xl text-sm font-semibold transition-all duration-300 transform hover:scale-105 ${
                isActive
                  ? 'bg-gradient-to-r from-primary-600/80 to-black/80 shadow-lg shadow-primary-500/25 border border-primary-500/30'
                  : 'bg-black/40 text-gray-300 hover:bg-black/60 hover:text-[#22c55e] border border-gray-700/30 hover:border-primary-600/30'
              }`}
              style={isActive ? { color: '#22c55e' } : {}}
              title={item.description}
            >
              <IconComponent className={`w-5 h-5 transition-colors duration-300 ${
                isActive ? 'text-primary-300' : 'text-gray-400 group-hover:text-primary-400'
              }`} />
              <span className="relative">
                {item.label}
                {isActive && (
                  <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-primary-400 to-transparent rounded-full"></div>
                )}
              </span>
              
              {/* Hover effect */}
              <div className={`absolute inset-0 rounded-xl bg-gradient-to-r from-primary-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${isActive ? 'opacity-20' : ''}`}></div>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
